import arrayReduce from './arrayReduce';

export default function reflushStyleNodes() {
  return arrayReduce(document.querySelectorAll('[data-fela-type]'), function (styleNodes, element) {
    var type = element.getAttribute('data-fela-type') || '';
    var media = element.getAttribute('media') || '';

    styleNodes[type + media] = element;
    return styleNodes;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/node_modules/fela-utils/es/reflushStyleNodes.js
// module id = 782
// module chunks = 0